import { defineMessages } from 'react-intl';

export default defineMessages({
  graphLegendTitle: { defaultMessage: 'Historical rates' },

  apy: { defaultMessage: 'APY' },
  variable: { defaultMessage: 'Variable' },
  stable: { defaultMessage: 'Stable' },
});
